import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const events = [{
  name: 'Sarah',
  city: 'Austin, TX',
  minutes: 2
}, {
  name: 'Michael',
  city: 'Denver, CO',
  minutes: 7
}, {
  name: 'Jennifer',
  city: 'San Diego, CA',
  minutes: 14
}, {
  name: 'David',
  city: 'Chicago, IL',
  minutes: 23
}, {
  name: 'Emily',
  city: 'Miami, FL',
  minutes: 31
}, {
  name: 'Carlos',
  city: 'Phoenix, AZ',
  minutes: 44
}, {
  name: 'Ashley',
  city: 'Nashville, TN',
  minutes: 58
}, {
  name: 'James',
  city: 'Boston, MA',
  minutes: 72
}];
export function LiveActivity() {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialDelay = setTimeout(() => setVisible(true), 8000);
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx(prev => (prev + 1) % events.length);
        setVisible(true);
      }, 500);
    }, 9000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(cycle);
    };
  }, [dismissed]);
  if (dismissed || !visible) return null;
  const event = events[idx];
  return <div className="fixed bottom-24 md:bottom-6 left-4 right-4 md:left-6 md:right-auto z-40 max-w-sm transition-all duration-500 animate-in slide-in-from-bottom-4 fade-in" role="status" aria-live="polite" data-id="element-340">
      <div className="bg-white rounded-xl shadow-2xl border border-[#3E2723]/10 p-3 md:p-4 flex items-center gap-3" data-id="element-341">
        <div className="bg-[#14B8A6]/15 p-2 rounded-full flex-shrink-0" data-id="element-342">
          <CheckCircle2 className="w-5 h-5 text-[#14B8A6]" data-id="element-343" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-344">
          <p className="text-sm text-[#3E2723] leading-tight" data-id="element-345">
            <strong data-id="element-346">{event.name}</strong> from {event.city}
          </p>
          <p className="text-xs text-[#3E2723]/60 mt-0.5" data-id="element-347">
            Just purchased · {event.minutes} min ago
          </p>
        </div>
        <button onClick={() => setDismissed(true)} aria-label="Dismiss" className="text-[#3E2723]/40 hover:text-[#3E2723] flex-shrink-0" data-id="element-348">
          <X className="w-4 h-4" data-id="element-349" />
        </button>
      </div>
    </div>;
}